<template>
    <div v-show="bodyIsShow">
        <div class="body">
            <div class="header">
                <div class="inner">
                    <div class="task-name">{{params.name}}</div>
                    <div class="task-state">
                        <span class="not" v-if="params.status == 1">未提交</span>
                        <span class="submitted" v-if="params.status == 2">已提交</span>
                        <span class="commented" v-if="params.status == 3">已点评</span>
                    </div>
                    <div class="task-date">
                        {{params.create_time_cn}}
                    </div>
                    <div class="task-question">
                        {{params.question}}
                    </div>
                </div>
            </div>
            <div class="my-task" v-if="!!myWork && myWork.user_id >0">
                <div class="my-task-title">
                    我的作业
                </div>
                <div class="my-task-center">
                    <div class="task-user-logo">
                        <img :src="myWork.photo" :onerror="defaultImg" />
                    </div>
                    <div class="task-user-content">
                        <div class="task-user-info">
                            <div class="task-user-name">
                                {{myWork.user_name}}
                            </div>
                        </div>

                        <div class="task-user-answer">
                            <div class="task-user-txt">
                                {{myWork.content}}
                            </div>
                            <div class="task-user-img" v-if="myWork.images.length>0">
                                <img @click="previewImg" v-for="(item,index) in myWork.images" :data-src="item" :src="item" />
                            </div>
                            <div class="task-user-btn">
                                <div class="task-user-time">
                                    {{myWork.create_time_cn}}
                                </div>
                            </div>
                        </div>

                        <div class="comment-area" v-if="myWork.comment != ''">
                            <div>
                                <div class="ca-item">
                                    <label class="pub-orange-text" style="font-weight:bold">老师点评</label>
                                    <div class="pub-orange-text">
                                        <span v-if="myWork.comment.length>80 && !myWork.open_text">
                                            {{myWork.comment.substring(0,80)+'...'}}<span style="color: #4395ff;" @click="openMyWorkCommentText">展开</span>
                                        </span>
                                         <span v-else>
                                            {{myWork.comment}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab" style="display:none">
                <div class="tabs upper">
                    <span class="iconfont iconshangyiye"></span>上一篇作业
                </div>
                <div class="tabs lower">
                    下一篇作业<span class="iconfont iconxiayiye"></span>
                </div>
            </div>
            <div class="task-dynamic">
                <div class="task-dynamic-title">
                    作业互动
                </div>

                <!--<van-pull-refresh v-model="refreshing" @refresh="answerListEvent(1)">-->
                    <van-list
                            v-model="loading"
                            :finished="finished"
                            finished-text="没有更多了"
                            :immediate-check="false"
                            @load="answerListEvent"
                    >

                        <div v-for="(item,index) in list">
                            <div class="task-dynamic-center">
                                <div class="task-user-logo">
                                    <img :src="item.photo" :data-index="index"
                                         :onerror="defaultImg" />
                                </div>
                                <div class="task-user-content">
                                    <div class="task-user-info">
                                        <div class="task-user-name">
                                            {{item.user_name}}
                                        </div>
                                    </div>
                                    <div class="task-user-answer">
                                        <div class="task-user-txt">
                                            {{item.content}}
                                        </div>
                                        <div class="task-user-img" v-if="item.images.length > 0">
                                            <img @click="previewImg" v-for="(imgItem,indexImg) in item.images" :data-index="index" :data-src="imgItem" :src="imgItem" />
                                        </div>
                                        <div class="task-user-btn">
                                            <div class="task-user-time">
                                                {{item.create_time_cn}}
                                            </div>
                                            <div class="task-message-btn" @click="handleProxy" :data-user_name="item.user_name" :data-work_answer_id="item.work_answer_id" :data-index="index">
                                                <span class="iconfont iconmessage"></span>
                                            </div>
                                            <div class="task-info-love" @click="favorSave" :data-index="index" :data-work_answer_id="item.work_answer_id">
                                                <span class="favor-cnt">{{item.favor_cnt}}</span><span class="iconfont iconaixin" :style="'color:'+(item.is_favor?'#f30':'#8a8a8a')"></span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="comment-area" v-if="item.comment != '' || item.replys.length >0">
                                        <div>
                                            <div class="ca-item" v-if="item.comment != ''">
                                                <label class="pub-orange-text" style="font-weight:bold">老师点评</label>
                                                <div class="pub-orange-text">
                                            <span v-if="item.comment.length>80 && !item.open_text">
                                                {{item.comment.substring(0,80)+'...'}}<span style="color: #4395ff;" @click="openCommentText" :data-index="index">展开</span>
                                            </span>
                                                    <span v-else>
                                                {{item.comment}}
                                            </span>
                                                </div>
                                            </div>

                                            <div class="ca-item" v-for="(items,indexReply) in item.replys" v-if="indexReply <3">
                                                <div @click="handleProxy" :data-user_name="items.user_name" :data-work_reply_id="items.work_reply_id"
                                                     :data-work_answer_id="item.work_answer_id" :data-index="index">
                                                    <label class="pub-user-text">{{items.user_name}}</label>
                                                    <span v-if="items.to_user_id>0" style="padding:0 5px">回复</span>
                                                    <label class="pub-user-text" v-if="items.to_user_id>0" >{{items.to_user_name}}</label>
                                                    ：
                                                    <span v-if="items.reply_content.length>80 && !items.open_text">
                                                {{items.reply_content.substring(0,80)+'...'}}<span style="color: #4395ff;" @click.stop="openReplyCommentText" :data-index="index" :data-reply_index="indexReply">展开</span>
                                            </span>
                                                    <span v-else>
                                                {{items.reply_content}}
                                            </span>
                                                </div>
                                            </div>
                                            <div class="ca-whole-item" v-if="item.replys.length>3" :data-work_answer_id="item.work_answer_id" :data-index="index" @click.stop="openMagList">
                                                查看全部回复<span class="iconfont icontubiao-"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </van-list>
                <!--</van-pull-refresh>-->
            </div>

            <div class="edit-task" @click="workEditEvent" v-if="!!params && params.status > 0 && !isChat">
                <span v-if="params.status == 1">写作业</span>
                <span v-if="params.status == 2">编辑作业</span>
                <span v-if="params.status == 3">查看作业</span>
            </div>

            <div class="send-chat" :style="'bottom:'+chatBottom+'px'" v-show="isChat">
                <input type="text"
                       :placeholder="MsgPlaceholder"
                       @focus="getChatBottom"
                       @blur="setChatBottom"
                       @keyup.enter="sendMsg"
                       ref="msgChat"
                       :value="MsgValue"
                       @input="setMsgDetail"
                />
                <div class="btn-send" @click="sendMsg">发送</div>
            </div>
        </div>
        <div :class="'mag-list '+(isOpenMagList?'i-as-mask-show':'')">
            <div :class="'msg-content '+(isOpenMagList?'i-as-show':'')" v-show="isOpenMagList">
                <div class="msg-header">
                    <div class="msg-header-txt">
                        评论详情页
                        <div class="icon" @click="closeMagList"><van-icon name="cross" size="16" color="#aaaaaa"/></div>
                    </div>
                </div>

                <div class="my-msg-list">
                    <div class="my-task" style="border:0">
                        <div class="my-task-center">
                            <div class="task-user-logo">
                                <img :src="msgWork.photo" :onerror="defaultImg" />
                            </div>
                            <div class="task-user-content">
                                <div class="task-user-info">
                                    <div class="task-user-name">
                                        {{msgWork.user_name}}
                                    </div>
                                </div>

                                <div class="task-user-answer">
                                    <div class="task-user-txt">
                                        {{msgWork.content}}
                                    </div>
                                    <div class="task-user-img">
                                        <img @click="previewImg" v-for="(item,index) in msgWork.images" :data-index="msgWork.index"  :data-src="item" :src="item" />
                                    </div>
                                    <div class="task-user-btn">
                                        <div class="task-user-time">
                                            {{msgWork.create_time_cn}}
                                        </div>
                                        <div class="task-message-btn" @click="handleProxy" :data-user_name="msgWork.user_name" :data-work_answer_id="msgWork.work_answer_id"
                                             :data-index="msgWork.index">
                                            <span class="iconfont iconmessage"></span>
                                        </div>
                                        <div class="task-info-love" @click="favorSave" :data-index="msgWork.index" :data-work_answer_id="msgWork.work_answer_id">
                                            <span class="favor-cnt">{{msgWork.favor_cnt}}</span><span class="iconfont iconaixin" :style="'color:'+(msgWork.is_favor?'#f30':'#8a8a8a')"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="text-align:center">
                        <div class="msg-h1">全部回复</div>
                    </div>


                    <!--<van-pull-refresh v-model="refreshingReply" @refresh="getReplyList(1)">-->
                        <van-list
                                v-model="loadingReply"
                                :finished="finishedReply"
                                finished-text="没有更多了"
                                :immediate-check="false"
                                @load="getReplyList"
                                style="margin-bottom: 50px;"
                        >
                            <div v-for="(item,index) in reply_list">
                                <div class="task-dynamic-center">
                                    <div class="task-user-logo">
                                        <img :src="item.user_photo" :data-index="index"
                                             :onerror="defaultImg" />
                                    </div>
                                    <div class="task-user-content">
                                        <div class="task-user-info">
                                            <div class="task-user-name">
                                                {{item.user_name}}
                                            </div>
                                        </div>
                                        <div class="task-user-answer">
                                            <div class="task-user-txt">
                                                {{item.reply_content}}
                                                <span v-if="item.to_user_id>0">
                                                <span style="margin:0 5px;color:#ccc">//@{{item.to_user_name}}:</span>
                                                {{item.to_reply_content}}
                                            </span>
                                            </div>
                                            <div class="task-user-btn">
                                                <div class="task-user-time">
                                                    {{item.create_time_cn}}
                                                </div>
                                                <div class="task-message-btn" @click="handleProxy" :data-user_name="item.user_name"
                                                     :data-work_reply_id="item.work_reply_id"
                                                     :data-work_answer_id="item.work_answer_id"
                                                     :data-index="msgWork.index">
                                                    <span class="iconfont iconmessage"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </van-list>
                    <!--</van-pull-refresh>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { List,PullRefresh,Icon,ImagePreview } from 'vant';
    export default {
        name: "detail",
        components:{
            [List.name]:List,
            [PullRefresh .name]:PullRefresh,
            [Icon.name]:Icon
        },
        data(){
            return{
                bodyIsShow:false,
                work_busy_id:'',
                params:{},
                myWork:[],
                list:[],
                total:0,
                is_show:false,
                page:1,
                pageSize:10,
                answerLoading:true,
                bodyHidden:false,
                defaultImg:'this.src="https://o-yzx.bysjy.com.cn/notice/photo_default.png"',

                loading: false,
                finished: false,
                refreshing: false,
                loadingReply: false,
                finishedReply: false,
                refreshingReply: false,

                chatBottom:0,//留言框bottom大小
                isChat:false,//显示留言输入框
                MsgValue:'',//留言类容
                MsgIndex:0,//留言位置
                work_answer_id:'',//问题ID
                to_work_reply_id:'',//回复人ID
                MsgPlaceholder:'回复',//留言默认显示提示
                isOpenMagList:false,//查看全部回复
                msgWork:[],//查看全部回复的当前人的主题内容

                reply_page:1,//回复列表页数
                reply_pageSize:10,//回复列表条数
                reply_list:[],//回复列表
                reply_total:0,//回复列表总数量
                is_reply_show:false,//回复列表无数据时是否显示提示
                replyLoading:true,//加载动画
            }
        },
        mounted() {
            this.util.hideOptionMenu();
            this.work_busy_id = this.util.getQueryStr('work_busy_id');
            this.answerListEvent(1);
            this.getDetail();
            this.myWorkEvent();
        },
        methods:{
            //作业图片查看
            previewImg(e){
                var img = e.currentTarget.dataset.src;
                var index = e.currentTarget.dataset.index;
                var arr=[];
                if(typeof index == "undefined"){
                    arr = this.myWork.images;
                }else{
                    arr = this.list[index].images;
                }

                var startPosition = 0;
                for (var i =0;i<arr.length;i++){
                    if(arr[i] == img){
                        startPosition = i;
                        break;
                    }
                }

                ImagePreview({
                    images:arr,
                    startPosition:startPosition,
                    closeable: true
                });
            },
            //展开文字
            openCommentText:function(e){
                var index = e.currentTarget.dataset.index;
                this.list[index].open_text = 1;
                this.$forceUpdate();
            },
            openMyWorkCommentText:function(e){
                this.myWork.open_text=1
                this.$forceUpdate();
            },
            openReplyCommentText:function(e){
                var index = e.currentTarget.dataset.index;
                var reply_index = e.currentTarget.dataset.reply_index;
                this.list[index].replys[reply_index].open_text = 1
                this.$forceUpdate();
            },
            //作业互动列表
            answerListEvent:function(page){
                var _self=this;
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page = pageNo;

                }else{

                    this.page = page;

                }
                this.util.server.mini_work.answer_list({
                    data:{
                        work_busy_id:this.work_busy_id,
                        page:this.page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;
                        this.refreshing= false;
                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.total = data.total;
                            }
                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                if(page == 1){
                                    this.list = data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.list = this.list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.loading = false;

                                if(this.total*1 == this.list.length){
                                    this.finished=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.list=[];
                                    this.finished=true;
                                    this.loading = false;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
            getDetail:function(){
                var _self=this;

                this.util.server.mini_work.get_detail({
                    data: {
                        work_busy_id:this.work_busy_id
                    },
                    callback: (res=>{
                        this.params=res.data;
                        this.bodyIsShow=true;
                    })
                })
            },
            myWorkEvent:function(){
                var _self=this;

                this.util.server.mini_work.my_work({
                    data:{
                        work_busy_id:this.work_busy_id
                    },
                    callback:(res=>{
                        this.myWork = res.data;
                    })
                })
            },
            //写/编辑/查看作业
            workEditEvent:function(){
                this.$router.push(this.util.urlPrefix+'/course_task/edit?work_busy_id='+this.work_busy_id+'&status='+this.params.status+'&token='+this.util.token);
            },
            //点赞
            favorSave:function(e){
                var index = e.currentTarget.dataset.index;
                var work_answer_id = e.currentTarget.dataset.work_answer_id;

                this.util.server.mini_work.favor({
                    data:{
                        work_answer_id:work_answer_id,
                    },
                    callback:(res=>{
                        if(res.code == -1){
                            return
                        }

                        var is_favor = this.list[index].is_favor;
                        var favor_cnt = this.list[index].favor_cnt;
                        this.list[index].is_favor = is_favor?0:1;
                        if(is_favor){
                            favor_cnt--
                        }else{
                            favor_cnt++
                        }
                        this.list[index].favor_cnt = favor_cnt;


                        // if(this.isOpenMagList){
                        //     var msgWork = this.msgWork;
                        //
                        //     this.msgWork = msgWork;
                        // }
                    })
                })
            },
            /********************************留言start*******************************/
            //点击留言
            handleProxy:function(e){
                this.isChat=true;
                this.work_answer_id = e.currentTarget.dataset.work_answer_id;
                this.MsgIndex = e.currentTarget.dataset.index;
                this.MsgPlaceholder = this.MsgPlaceholder + ' '+e.currentTarget.dataset.user_name;
                this.to_work_reply_id = e.currentTarget.dataset.work_reply_id || '';

                this.$nextTick(function () {
                    this.$refs.msgChat.focus();
                })
            },
            //获取输入法高度
            getChatBottom:function(e){
                this.chatBottom = e.target.height || 0;
            },
            //初始化留言bottom
            setChatBottom:function(){
                this.chatBottom=0;
                if(this.MsgValue  == ''){
                    this.isChat = false;
                    this.work_answer_id='';
                    this.to_work_reply_id='';
                    this.MsgValue='';
                    this.MsgIndex=0;
                    this.MsgPlaceholder='回复';
                }
            },
            //发送留言
            sendMsg:function(e){
                var val = this.MsgValue.replace(/\s+/g, '');
                var _self=this;
                if(val == ''){
                    this.isChat = false;
                    this.work_answer_id='';
                    this.to_work_reply_id='';
                    this.MsgIndex=0;
                    this.MsgPlaceholder='回复';
                    return false;
                }

                this.util.server.mini_work.reply({
                    data:{
                        work_answer_id:this.work_answer_id,
                        to_work_reply_id:this.to_work_reply_id,
                        reply_content:val
                    },
                    callback:(res=>{

                        if(res.code == -1){
                            this.isChat = false;
                            this.work_answer_id='';
                            this.to_work_reply_id='';
                            this.MsgIndex=0;
                            this.MsgValue='';
                            this.MsgPlaceholder='回复';
                            return false;
                        }

                        var replyArr = this.list[this.MsgIndex].replys;

                        var arr=[];
                        arr.push(res.data);
                        arr = arr.concat(replyArr);

                        this.list[this.MsgIndex].replys = arr;

                        if(this.isOpenMagList){
                            var replyArr = this.reply_list;

                            var arr=[];
                            arr.push(res.data);
                            arr = arr.concat(replyArr);

                            this.reply_list=arr;
                        }

                        this.isChat = false;
                        this.work_answer_id='';
                        this.to_work_reply_id='';
                        this.MsgIndex=0;
                        this.MsgValue='';
                        this.MsgPlaceholder='回复';
                    })
                })
            },
            //回显输入内容
            setMsgDetail:function(e){
                this.MsgValue=e.target.value;
            },
            //查看全部回复
            openMagList:function(e){
                var index =e.currentTarget.dataset.index;
                var work = this.list[index];
                var work_answer_id = e.currentTarget.dataset.work_answer_id;
                work.index =index;

                this.isOpenMagList = true;
                this.bodyHidden = true;
                document.querySelector('body').setAttribute('style','overflow-y:hidden');
                this.msgWork = work;
                this.work_answer_id = work_answer_id;

                this.getReplyList(1);
            },
            getReplyList:function(page){

                var _self=this;
                if(!page){
                    var pageNo = this.reply_page;
                    pageNo +=1;

                    this.reply_page = pageNo;

                }else{

                    this.reply_page=page;

                }

                this.util.server.mini_work.reply_list({
                    data:{
                        work_answer_id:this.work_answer_id,
                        page:this.reply_page,
                        pagesize:this.reply_pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;
                        this.refreshingReply=false;

                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.reply_total = data.total;
                            }
                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                if(page == 1){
                                    this.reply_list = data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.reply_list = this.reply_list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.loadingReply = false;

                                if(this.reply_total*1 == this.reply_list.length){
                                    this.finishedReply=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.reply_list=[];
                                    this.finishedReply=true;
                                    this.loadingReply = false;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
            //关闭全部回复
            closeMagList:function(){
                this.isOpenMagList=false;
                this.bodyHidden=false;
                document.querySelector('body').setAttribute('style','overflow-y:auto');
                this.msgWork=[];
                this.work_answer_id='';
                this.reply_list=[];
                this.reply_total=0;
            },
        }
    }
</script>

<style scoped>
    input {
        cursor: auto;
        display: block;
        height: 1.4rem;
        text-overflow: clip;
        overflow: hidden;
        white-space: nowrap;
        font-family: UICTFontTextStyleBody;
        min-height: 1.4rem;
        border: 0;
        width: 86%;
    }
    .my-msg-list{
        height:100%;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        overflow-x: hidden;
        overflow-y: auto;
    }
    .my-msg-list::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }
    div{
        color: #3a3a3a;
    }
    .body{
        background-color: #ffffff;
        width: 100%;
        height: 100%;
    }
    .overflow-hidden{
        overflow: hidden;
    }
    .header{
        padding: 10px;
    }
    .inner{
        position: relative;
    }
    .inner .task-name{
        padding-right: 50px;
        display: inline-block;
        width: 100%;
        box-sizing: border-box;
    }
    .inner .task-state{
        position: absolute;
        top: 0;
        right: 0;
    }
    .inner .task-date{
        font-size: 12px;
        color: #aaa;
        padding-top: 5px;
        padding-bottom: 10px;
    }
    .task-state .not{
        color: #f30;
    }
    .task-state .commented{
        color: #57c78b;
    }
    .task-state .submitted{
        color: #337ab7;
    }
    .tab{
        width: 100%;
        margin: 0;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        padding: 8px;
        box-sizing: border-box;
        display: flex;
    }
    .tab .tabs{
        display: inline-block;
        flex: 1;
    }
    .tabs span{
        vertical-align: middle;
    }
    .tabs.lower{
        text-align: right;
    }
    .my-task{
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        margin: 0 0 -1px -1px;
        padding: 10px;
    }
    .my-task .my-task-title{
        padding-bottom: 2px;
        border-bottom: 3px solid #666;
        width: 90px;
        font-weight: bold;
    }
    .my-task .my-task-center{
        margin: 10px 0;
        position: relative;
    }
    .task-user-logo{
        width: 40px;
        font-size: 0;
        position: absolute;
        top: 0;
    }
    .task-user-logo img{
        width: 40px;
        height: 40px;
        border-radius: 20px;
    }
    .task-user-content{
        display: inline-block;
        width: 100%;
        padding-left: 50px;
        box-sizing: border-box;
    }
    .task-user-info{
        position: relative;
        height: 40px;
        line-height: 40px;
    }
    .task-user-info .task-user-name{
        width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .task-user-info .task-edit{
        position: absolute;
        right: 0;
        top: 0;
        width: 40px;
        text-align: center;
        color: #4395ff;
    }
    .task-user-answer .task-user-img{
        overflow: hidden;
        margin-top: 15px;
        font-size: 0;
    }
    .task-user-answer .task-user-img img{
        width: 40px;
        height: 40px;
        border-radius: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
    }
    .task-user-answer .task-user-txt{
        margin: 10px 0;
    }
    .task-user-btn{
        display: flex;
    }
    .task-user-btn .task-user-time{
        font-size: 12px;
        color: #aaa;
        flex: 1;
    }
    .task-user-btn .task-message-btn{
        width: 40px;
        text-align: center;
    }
    .task-user-btn .task-info-love{
        text-align: right;
        min-width: 40px;
    }
    .task-user-btn .iconfont{
        color: #8a8a8a;
        font-size: 20px;
    }
    .task-dynamic{
        padding: 10px;
        margin-bottom: 40px;
    }
    .task-dynamic-title{
        padding-bottom: 2px;
        border-bottom: 3px solid #666;
        width: 90px;
        font-weight: bold;
    }
    .task-dynamic-center{
        margin: 10px 0;
        position: relative;
    }
    .comment-area{
        background: #f5f5f5;
        border-radius: 4px;
        margin-top: 5px;
        padding: 5px 0;
        margin-bottom: 5px;
        position: relative;
    }
    .comment-area::before{
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-color: transparent transparent #f5f5f5 transparent;
        border-top-width: 0;
        top: -8px;
        left: 20px;
    }
    .comment-area .ca-item{
        padding: 0 5px;
        position: relative;
    }
    .pub-orange-text{
        color: #ff9234;
    }
    .ca-whole-item{
        font-size: 12px;
        padding: 0 5px;
        color: #4395ff;
        padding-top: 5px;
    }
    .ca-whole-item .iconfont{
        vertical-align: middle;
    }
    .edit-task{
        position: fixed;
        bottom: 0;
        background-color: #fff;
        width: 100%;
        border-top: 1px solid #ccc;
        text-align: center;
        padding: 10px 0;
    }
    .pub-user-text{
        color: #71a3ae;
    }
    .send-chat{
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 5px;
        background-color: #fff;
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        z-index: 99999;
    }
    .send-chat input{
        padding: 5px;
        background-color: #f3f3f3;
        padding-right: 47px;
    }
    .chat-content .chat-details{
        width: 100%;
        height: 100%;
        padding: 10px;
        /*overflow-y: auto;*/
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .send-chat .btn-send{
        position: absolute;
        top: 0;
        right: 0;
        height: 1.4rem;
        margin-right: 5px;
        margin-top: 5px;
        padding: 5px;
        line-height: 1.4rem;
        letter-spacing: 2px;
        border-left: 1px solid #ccc;
    }
    .mag-list{
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.5);
        transition:all .2s ease-in-out;
        opacity:0;
        visibility:hidden
    }
    .i-as-mask-show{
        opacity:1;
        visibility:visible
    }
    .mag-list .msg-content{
        height: 90%;
        width: 100%;
        position: absolute;
        background-color: #ffffff;
        transform:translate3d(0,100%,0);
        transform-origin:center;
        transition:all .2s ease-in-out;
        top: 10%;
        visibility:hidden;
        z-index: 10;
        border-radius: 20px 20px 0 0;
        overflow: hidden;
        padding: 0 15px;
        box-sizing: border-box;
    }
    .mag-list .i-as-show{
        transform:translate3d(0,0,0);
        visibility:visible
    }
    .msg-header .msg-header-txt{
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
        position: relative;
    }
    .msg-header-txt .icon{
        position: absolute;
        right: 0;
        top: 10px;
    }
    .msg-h1{
        font-weight: bold;
        font-size: 16px;
        text-align: center;
        position: relative;
        display: inline-block;
    }
    .msg-h1:after,.msg-h1:before{
        content: '';
        position: absolute;
        height: 2px;
        width: 30px;
        background-color: #ccc;
        top: 50%;
        border-radius: 2px;
    }
    .msg-h1:before{
        left: -40px;
    }
    .msg-h1:after{
        right: -40px;
    }
    .no-list{
        text-align: center;
        width: 100%;
        margin-bottom: 40px;
    }
    .favor-cnt{
        font-size: 12px;
        vertical-align: middle;
    }
    .task-info-love .iconaixin{
        vertical-align: middle;
    }
</style>
